import { IconWrapper } from '../runtime';
export default IconWrapper('garbage-can', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M5.75 1.33203H10.25M1.75 3.75H14.25M12.5 4.25L11.6351 12.8993C11.5584 13.6661 10.9131 14.25 10.1425 14.25H5.85748C5.08685 14.25 4.44161 13.6661 4.36493 12.8993L3.5 4.25M8 6.75V10.25",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});